import { render, staticRenderFns } from "./KiPilotTheorie.vue?vue&type=template&id=ceb3dd00"
import script from "./KiPilotTheorie.vue?vue&type=script&lang=ts"
export * from "./KiPilotTheorie.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports